<template>
  <b-container>  
    <loading :active.sync="isLoading" color="#00AB63"></loading> 
    <b-row>
      <b-col sm="12">
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Agregar cliented</h4> 
          <div class="media text-muted pt-3">
            <b-form @submit="onSubmit"  v-if="show" style="width: 100%;">
              <b-row>
                <b-col sm="6">
                  <b-form-group label="Nombres">
                    <b-form-input
                      v-model="form.Firstname"
                      type="text"
                      required
                      placeholder="Nombre"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group label="Apellidos">
                    <b-form-input
                      v-model="form.Lastname"
                      type="text"
                      required
                      placeholder="Apellidos"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Correo electronico">
                    <b-form-input
                      v-model="form.Email"
                      type="email"
                      required
                      placeholder="Correo electronico"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Teléfono" label-for="input-1">
                    <b-form-input
                      v-model="form.phoneNumber"
                      type="tel"
                      required
                      placeholder="Teléfono"  
                    />
                  </b-form-group> 
                </b-col>
              </b-row>
              

              <b-button  variant="primary" class="float-right boton_createch" type="submit">
                <i class="far fa-save"></i> Guardar
              </b-button>
            </b-form>
          </div>
        </div>
      </b-col> 
    </b-row>
    <b-row>
      <b-col>
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Clientes</h4> 
          <div class="media text-muted pt-3">
            <b-container>
              <!-- User Interface controls -->
              <b-row class="mb-4">
                <b-col sm="10">
                  <b-form-group label="Buscar" label-for="filterInput" class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input v-model="filter" type="search" id="filterInput"></b-form-input>
                      <b-input-group-append>
                        <b-button class="boton_createch" :disabled="!filter" @click="filter = ''">Borrar</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              
                <b-col sm="2">
                  <b-form-group label="Por Pagina" label-for="perPageSelect" class="mb-0">
                    <b-form-select
                      v-model="perPage"
                      id="perPageSelect"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- Main table element --> 
              <b-table
                show-empty
                small
                stacked="md"
                :items="usuarios"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :filterIncludedFields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
              >
                <template v-slot:cell(name)="row">{{ row.value.first }} {{ row.value.last }}</template>

                <template v-slot:cell(actions)="row">
                    <b-button  size="sm" @click="view(row.item)" class="mr-1 btn_editar">
                      <i class="far fa-eye"></i>
                    </b-button>
                    <b-button 
                      size="sm"
                      @click="editar(row.item, row.index, $event.target)"
                      class="mr-1 btn_editar"
                    >
                      <i class="far fa-edit"></i>
                    </b-button>
                    <b-button 
                      size="sm"
                      @click="eliminar(row.item, row.index, $event.target)"
                      class="mr-1 btn_borrar"
                    >
                      <i class="far fa-trash-alt"></i>
                    </b-button>
                </template>

                <template v-slot:row-details="row">
                  <b-card>
                    <ul>
                      <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                    </ul>
                  </b-card>
                </template>
              </b-table>
              <b-container>
                <b-row class="justify-content-end">
                  <b-col sm="5">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="fill"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-container>

          
              <!-- Delete modal -->
              <b-modal
                :id="deleteModal.id"
                :title="deleteModal.title"
                @ok="eliminarCliente(deleteModal.eliminar)"
                centered 
                ok-title="Eliminar"
                cancel-title="Cancelar"
              >
                <p
                  style="text-align:center; font-size:25px; font-weight:bold;"
                >¿Está seguro que desea eliminar?</p>
              </b-modal>

              <!-- Editar modal -->
              <b-modal :id="editModal.id" size="lg" :title="editModal.title" centered hide-footer>
                <b-container>
                  <b-row>
                    <b-form @submit.prevent="actualizar()" v-if="show" style="width: 100%;">
                      <b-row>
                        <b-col sm="6">
                          <b-form-group label="Nombre">
                            <b-form-input
                              v-model="editModal.new.firstname"
                              type="text"
                              required
                              placeholder="Nombre"
                              tabindex="1"
                            />
                          </b-form-group>
                          <b-form-group label="Correo electronico">
                            <b-form-input
                              v-model="editModal.new.email"
                              type="email"
                              required
                              placeholder="Correo electronico"
                              tabindex="3"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group label="Apellidos">
                            <b-form-input
                              v-model="editModal.new.lastname"
                              type="text"
                              required
                              placeholder="Apellidos"
                              tabindex="2"
                            />
                          </b-form-group> 
                        </b-col>
                      </b-row> 
                      <hr />
                      <b-row>
                        <b-col>
                          <div class="float-right">
                            <b-button
                              variant="secondary"
                              size="sm"
                              class="mr-1"
                              @click="ocultaModal(editModal.id)"
                            >Cancelar</b-button>
                            <b-button
                              type="submit"
                              variant="primary"
                              size="sm"
                              :disabled="editModal.disableBtn"
                            >Editar</b-button>
                          </div>
                        </b-col>
                      </b-row>
                    </b-form>
                  </b-row>
                </b-container>
              </b-modal>
            </b-container>
          </div>
        </div>
      </b-col>
    </b-row>     
    
  </b-container>
</template>

<script>
import Ultimos from "@/components/Empleados/Ultimos.vue";

import axios from "axios";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Ultimos,
    Loading
  },
  data() {
    return {
      isLoading: false,
      noServicio: {
        cliente: null,
        numero: ""
      },
      form: {
        Firstname: "",
        Lastname: "",
        Password: "",
        PasswordRepeat: "",
        phoneNumber: null,
        Email: "",
        
        Rol: "Cliente"
      },
      foods: [
        { text: "Selecciona rol de usuario", value: null },
        "Administrador",
        "Supervisor",
        "Vendedor"
      ],
      show: true,
      usuarios: [],
      fields: [
        { key: 'firstname', label: 'Nombre' }, 
            { key: 'lastname', label: 'Apellido' }, 
            { key: 'phoneNumber', label: 'Teléfono' },  
            { key: 'email', label: 'Correo electrónico' },  
            { key: 'servicesNumbers', label: 'No. Servicios' },
            { key: 'quotes', label: 'No. Cotizaciones' },
        { key: "actions", label: "" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      },
      deleteModal: {
        id: "info-modal",
        title: "",
        eliminar: null
      },
      editModal: {
        id: "edit-modal",
        title: "",
        new: { newPassword: "", passwordRepeat: "" },
        setPassword: false
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  created() {
    this.listar();
  },
  methods: {
    NoServicio(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    toggleDetails(item) {
      this.form.Firstname = item.Firstname;
      this.form.Lastname = item.Lastname;
      this.form.Password = item.Password;
      this.form.PasswordRepeat = item.PasswordRepeat;
      this.form.Email = item.Email;
      this.form.Rol = item.Rol;
      window.scrollTo(0, 0);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    eliminarCliente() {
      this.isLoading = true;
      axios
        .delete(`user/${this.deleteModal.eliminar}`)
        .then(res => {
          this.listar();
          this.isLoading = false; 
          this.ocultaModal(this.deleteModal.id);
        }) 
        .catch(error => {});
    },
    actualizar() { 
      this.isLoading = true;   
      axios
        .put(`user/${this.editModal.new._id}`, {
          firstname: this.editModal.new.firstname,
          lastname: this.editModal.new.lastname,
          email: this.editModal.new.email
        })
        .then(res => { 
          if (res.status === 202) {
            this.makeToast(
              "Ya existe una usuario con ese correo electrónico.",
              "Editar usuario."
            );
            this.isLoading = false;
          } else {
            this.listar(); 
            this.isLoading = false;
          }
        })
        .then(res => { 
          this.ocultaModal(this.editModal.id);
        })
        .catch(error => {}); 
    },
    view(iduser) { 
      this.$router.push({ name: "cliente_id",  params: { id: iduser._id ,cliente: ""+iduser.firstname+" "+iduser.lastname+"" } });
    },
    eliminar(item, button) { 
      this.deleteModal.eliminar = item._id;
      this.deleteModal.title = `Eliminar cliente: ${item.firstname} ${item.lastname}`;
      this.$root.$emit("bv::show::modal", this.deleteModal.id, button);
    },
    editar(item, index, button) {
      this.resetModal();
      this.editModal.new.firstname = item.firstname;
      this.editModal.new.lastname = item.lastname;
      this.editModal.new.email = item.email;
      this.editModal.new._id = item._id; 
      this.editModal.new.newPassword = "";
      this.editModal.new.passwordRepeat = "";
      this.editModal.title = `Editar cliente: ${item.firstname} ${item.lastname}`;
      this.$root.$emit("bv::show::modal", this.editModal.id, button);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    listar() {
      let me = this; 
      this.isLoading = false;  
    
      axios.get('customers/'+this.$store.state.usuario._id+'/status=true').then(function (response){  
          me.totalRows = response.data.customers.length; 
          me.usuarios=response.data.customers;
      }).catch(function(error){
      });
      
    },
    registrar() {
      this.isLoading = true;
      axios
        .post("user", {
          id_creador: this.$store.state.usuario._id,
          usuario: {
            firstname: this.form.Firstname,
            lastname: this.form.Lastname, 
            email: this.form.Email,
            phoneNumber: this.form.phoneNumber,
            rol: "Cliente"
          }
        })
        .then(respuesta => {
          return respuesta;
          this.isLoading = false;
        })
        .then(data => {
          this.form.Firstname = "";
          this.form.Lastname = "";
          this.form.Password = "";
          this.form.Email = "";
          this.form.Rol = "";
          this.listar();
          this.isLoading = false;
        })
        .catch(error => {
          this.errorM = null;
          if (error.response.data == "Usuario ya existe") {
            this.makeToast(
              this.$bvToast.toast(error.response.data, {
                title: "Error",
                toaster: "b-toaster-top-right",
                variant: "danger",
                solid: true
              })
            );
            this.isLoading = false;
          } else {
            this.errorM = "Ocurrió un error revisa los campos.";
            this.isLoading = false;
          }
        });
    },
    onEnter: function() {
      this.registrar();
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.registrar();
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.Firstname = "";
      this.form.Lastname = "";
      this.form.Password = "";
      this.form.Email = "";
      this.form.Rol = "";
      this.form.phoneNumber = null;
    },
    ocultaModal(id) {
      this.$bvModal.hide(id);
    },
    resetModal() {
      this.editModal.new = {
        firstname: "",
        lastname: "",
        email: "",
        _id: "",
        rol: "",
        newPassword: "",
        passwordRepeat: ""
      };
      this.editModal.setPassword = false;
    }
  }
};
</script>
<style>
a.nav-link {
  color: #333 ;
}
</style>